import { DocumentTemplateType } from '../../../api-client/autogenerated';
import { CENTERLINE_AI_ENABLED, useCenterlineAiAvailable } from '../centerline-ai-access';
import { hasReviewPermission, reviewKindFor, showsReviewRow } from './review-visibility';

/**
 * Who is offered the CENTERLINE AI reviewer on a document (docs/superpowers/plans/
 * 2026-10-16-centerline-ai-document-review.md §4.1). Every condition must hold, and none of them
 * widens a backend permission: the token route still enforces CENTERLINE AI access, and the Query
 * Tool's project scoping is unchanged.
 */

/**
 * Build-time switch, off unless the build sets REACT_APP_CENTERLINE_AI_DOCUMENT_REVIEW=true, on top
 * of REACT_APP_ENABLE_CENTERLINE_AI. Without it nothing about the reviewer renders or is asked.
 */
export const CENTERLINE_AI_DOCUMENT_REVIEW_ENABLED =
  CENTERLINE_AI_ENABLED && process.env.REACT_APP_CENTERLINE_AI_DOCUMENT_REVIEW === 'true';

/**
 * Whether to show the reviewer on this document. The backend is asked about the project only when
 * everything the frontend can tell already allows it, so no one else costs a request.
 */
export function useShowCenterlineAiReview(args: {
  projectId: string | undefined;
  docType: DocumentTemplateType | null | undefined;
  isPackage: boolean;
  permission: number | null | undefined;
}): boolean {
  const { projectId, docType, isPackage, permission } = args;
  const eligible =
    CENTERLINE_AI_DOCUMENT_REVIEW_ENABLED &&
    reviewKindFor(docType, isPackage) !== null &&
    hasReviewPermission(permission);
  const available = useCenterlineAiAvailable(eligible ? projectId : undefined);
  return showsReviewRow({
    flagOn: CENTERLINE_AI_DOCUMENT_REVIEW_ENABLED,
    docType,
    isPackage,
    permission,
    available,
  });
}
